<template lang="pug">
span {{ name }}
</template>

<script>
export default {
  name: "InventoryInListProductName",
  props: ["products", "id"],
  computed: {
    name() {
      if (this.id) {
        const found = this.products?.find((o) => o._id == this.id);
        return found?.name || this.id;
      }
      return "";
    },
  },
};
</script>